// Marca del panel clínico — CardioBaus (único archivo distinto entre los dos sitios)
export const BRAND = {
  key: "cardiobaus",
  name: "CardioBaus",
  doctor: "Dr. Bolívar Baus",
  tagline: "Cardiología Integral",
  logo: "/img/logo.webp",
  email: "citas@cardiobaus.com",
  phone: "+593 96 318 8089",
  address: "Av. Joaquín Orrantia y Av. Juan Tanca Marengo, Edif. Ágora XXI, Piso 5, Consultorio 510 · Guayaquil",
  defaultPlace: "Cenincardio",
  tokenKey: "cb_token",
  themeKey: "cb_theme",
  services: ["Consulta cardiológica", "Control / seguimiento", "Cardiopulmonar", "Cardiorenal", "Cardiometabólico", "Electrocardiograma", "Ecocardiograma"],
  slotHours: [9, 17],
  openSundays: false,
  reminderRule: "(7 días antes a pacientes crónicos; 5 días antes al resto si la cita es a 30 días o más de la atención).",
  cssVars: { "--brand": "#E11D48", "--brand2": "#EC4899", "--accent": "#38BDF8", "--font-head": "'Outfit', 'Plus Jakarta Sans', sans-serif" },
};
